export type ConventionTagCategory = 'language' | 'framework' | 'platform' | 'domain';

export type ConventionTagDefinition = {
  value: string;
  category: ConventionTagCategory;
};

export const CONVENTION_TAG_DEFINITIONS: ConventionTagDefinition[] = [
  { value: 'TypeScript', category: 'language' },
  { value: 'JavaScript', category: 'language' },
  { value: 'Python', category: 'language' },
  { value: 'Go', category: 'language' },
  { value: 'Rust', category: 'language' },
  { value: 'Java', category: 'language' },
  { value: 'Kotlin', category: 'language' },
  { value: 'Swift', category: 'language' },

  { value: 'React', category: 'framework' },
  { value: 'Next.js', category: 'framework' },
  { value: 'Vue', category: 'framework' },
  { value: 'Svelte', category: 'framework' },
  { value: 'Fastify', category: 'framework' },
  { value: 'Express', category: 'framework' },
  { value: 'NestJS', category: 'framework' },
  { value: 'Django', category: 'framework' },
  { value: 'FastAPI', category: 'framework' },
  { value: 'Spring', category: 'framework' },
  { value: 'Prisma', category: 'framework' },

  { value: 'Web', category: 'platform' },
  { value: 'Mobile', category: 'platform' },
  { value: 'CLI', category: 'platform' },
  { value: 'Desktop', category: 'platform' },
  { value: 'Backend', category: 'platform' },
  { value: 'Infrastructure', category: 'platform' },

  { value: 'Testing', category: 'domain' },
  { value: 'CI/CD', category: 'domain' },
  { value: 'Security', category: 'domain' },
  { value: 'Performance', category: 'domain' },
  { value: 'Documentation', category: 'domain' },
  { value: 'Code Review', category: 'domain' },
  { value: 'Git Workflow', category: 'domain' },
  { value: 'Database', category: 'domain' },
  { value: 'AI Agent', category: 'domain' },
];

export const CONVENTION_TAG_CATEGORY_ORDER: ConventionTagCategory[] = ['language', 'framework', 'platform', 'domain'];

export const groupConventionTags = () => {
  const groups = new Map<ConventionTagCategory, string[]>();
  for (const definition of CONVENTION_TAG_DEFINITIONS) {
    const existing = groups.get(definition.category) ?? [];
    existing.push(definition.value);
    groups.set(definition.category, existing);
  }
  return groups;
};

const MAX_TAG_LENGTH = 50;
const TAG_PATTERN = /^[A-Za-z0-9][A-Za-z0-9 .+/#\-_]*$/;

export const normalizeConventionTag = (raw: string): string | null => {
  const trimmed = raw.trim();
  if (trimmed.length === 0 || trimmed.length > MAX_TAG_LENGTH) {
    return null;
  }
  if (!TAG_PATTERN.test(trimmed)) {
    return null;
  }
  return trimmed;
};
